import React, { ComponentProps } from 'react'
import { Field } from 'react-final-form'

import { FieldValidator } from 'final-form'
import Utils from 'Utils'

import DateInput from './DateInput'

type Props = ComponentProps<typeof DateInput> & {
  name: string
  checkErrorIfDirty?: boolean
  displayError?: boolean
  validate?: FieldValidator<Date>
}

function DateInputField({
  checkErrorIfDirty,
  displayError = true,
  name,
  validate,
  ...rest
}: Props) {
  return (
    <Field<Date> name={name} validate={validate}>
      {({ input: { value, onChange: handleChange }, meta }) => {
        // @ts-expect-error
        const { hasError, error } = Utils.Form.hasError(meta, checkErrorIfDirty)

        return (
          <DateInput
            {...rest}
            caption={displayError && error}
            danger={hasError}
            value={value}
            onChange={handleChange}
          />
        )
      }}
    </Field>
  )
}

export default DateInputField
